module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _currencySymbolText;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Module dependencies
 */
var React = __webpack_require__(2);

var PropTypes = __webpack_require__(1);

/**
 * currencySymbolMap
 * Translate currency symbol to natural language for accessibility purpose.
 */
var currencySymbolText = (_currencySymbolText = {
  '$': 'pesos',
  'U$S': 'dólares',
  'Bs': 'bolivianos',
  'R$': 'reais',
  '¢': 'colones',
  '€': 'euros',
  'Q': 'quetzal guatemaltecos',
  'L': 'lempiras',
  'C$': 'córdobas'
}, _defineProperty(_currencySymbolText, 'C$', 'balboas'), _defineProperty(_currencySymbolText, 'S/', 'soles'), _defineProperty(_currencySymbolText, '₲', 'guaraníes'), _defineProperty(_currencySymbolText, 'Bs.', 'bolivares'), _currencySymbolText);

/**
 * amountFormat
 * Note: This function shall be only used to set
 * the price for SEO purposes (i.e. metatags).
 *
 * We're removing the thousand separators in the
 * fraction and using dot instead of `decimal_separator`
 * to comply with http://schema.org/price
 */
var amountFormat = function amountFormat(_ref) {
  var fraction = _ref.fraction,
      cents = _ref.cents;

  fraction = fraction.replace(/[,\.]/g, '');
  if (cents !== null && cents !== undefined) {
    return fraction + '.' + cents;
  }
  return fraction;
};

/**
 * isNegative
 * TODO: Use fraction.startsWith('-') in a future.
 */
var isNegative = function isNegative(fraction) {
  return fraction[0] === '-';
};

/**
 * absAmount
 * Returns the absolute value of a given amount.
 */
var absAmount = function absAmount(fraction) {
  return isNegative(fraction) ? fraction.replace('-', '') : fraction;
};

/**
 * VissuallyHidden
 */
var VissuallyHidden = function VissuallyHidden(_ref2) {
  var children = _ref2.children;
  return _jsx('span', {
    className: 'price-tag-text-sr-only'
  }, void 0, children);
};

/**
 * amountToSpeech
 */
var amountToSpeech = function amountToSpeech(amount, disabled) {
  var txt = disabled ? 'Antes: ' : '';
  // fraction
  txt += amount.fraction.replace(/\.|\,/g, '');
  // symbol to text
  txt += ' ' + (amount.symbol_text || currencySymbolText[amount.symbol]);
  // cents
  txt += amount.cents ? ' con ' + amount.cents + ' centavos ' : '';
  // discount
  txt += amount.discount ? ' (' + amount.discount + ')' : '';
  return txt;
};

/**
 * Price Component
 */
var Price = function Price(_ref3) {
  var amount = _ref3.amount,
      billing = _ref3.billing,
      disabled = _ref3.disabled,
      meta = _ref3.meta,
      className = _ref3.className;

  var Element = disabled ? 's' : 'span';

  var classNames = 'price-tag';
  if (className) {
    classNames += ' ' + className;
  }
  if (billing) {
    classNames += ' price-tag-billing';
  }
  if (disabled) {
    classNames += ' price-tag__disabled';
  }

  return _jsx(Element, {
    className: classNames,
    itemProp: meta ? 'offers' : undefined,
    itemScope: meta ? true : undefined,
    itemType: meta ? 'http://schema.org/Offer' : undefined
  }, void 0, meta && _jsx('meta', {
    itemProp: 'price',
    content: amountFormat(amount)
  }), _jsx(VissuallyHidden, {}, void 0, amountToSpeech(amount, disabled)), _jsx('span', {
    className: 'price-tag-amount',
    'aria-hidden': 'true'
  }, void 0, isNegative(amount.fraction) && _jsx('span', {
    className: 'price-tag-negative-symbol'
  }, void 0, '-'), _jsx('span', {
    className: 'price-tag-symbol',
    itemProp: meta ? 'priceCurrency' : undefined,
    content: meta ? amount.currency_id : undefined
  }, void 0, amount.symbol), _jsx('span', {
    className: 'price-tag-fraction'
  }, void 0, absAmount(amount.fraction)), amount.cents && [_jsx('span', {
    className: 'price-tag-decimal-separator'
  }, 'decimalSeparator', amount.decimal_separator), _jsx('span', {
    className: 'price-tag-cents'
  }, 'centsAmount', amount.cents)], amount.discount && _jsx('span', {
    className: 'price-tag-discount'
  }, void 0, amount.discount)));
};

/**
 * propTypes
 */


/**
 * Default props
 */
Price.defaultProps = {
  className: '',
  billing: false,
  disabled: false,
  meta: false,
  discount: ''
};

/**
 * Expose Price
 */
exports = module.exports = Price;

/**
 * Expose for testing
 */
if (false) {
  exports = module.exports;
  exports.amountFormat = amountFormat;
  exports.absAmount = absAmount;
  exports.isNegative = isNegative;
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);